'use client';

import { useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';

import { MobileLayout } from '@ui/components/features/layout/mobileLayout/mobileLayout';
import { useBackNavigation } from '@website/hooks/useBackNavigation';

export function ActivityDetailMobileLayout({ children }: { children: React.ReactNode }) {
  const params = useParams();
  const locale = params?.locale as string;
  const t = useTranslations('Common');

  const handleBack = useBackNavigation(`/${locale}/search`);

  return (
    <MobileLayout onBack={handleBack} backLabel={t('goBack')} transparent={true} className="flex-1" noPadding>
      {children}
    </MobileLayout>
  );
}
